module.exports = __webpack_public_path__ + "img/cta1.d17be06d.svg";